/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLLocalDateUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import { QuestionSetComponent } from 'ml-components-platform-react';
import moment from 'moment';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';

import _ from 'lodash';
import metadata from './PriorInsuranceComponent.metadata.json5';
import messages from './PriorInsuranceComponent.messages';

const PA_QUESTIONSET_PATH = 'lobData.personalAuto.questionSets_ML.priorInsurance.value';
const HOP_QUESTIONSET_PATH = 'lobData.homeowners.priorInsurance.value[0]';
const isQnB = appConfig.portalCode === 'QB';

function PriorInsuranceComponent(props) {
    const { refreshData } = useDataRefresh();
    const {
        submissionVM, currentStep, updateWizardData, onValidate, onUpdateErrors, syncQuestionSets, showErrors, isGpa, isFieldDefaultedByHVQ, showPriorInsuranceErrors, updateShowPriorInsuranceErrors
    } = props;
    const translator = useTranslator();
    const { MLUserTypes } = appConfig;

    const getPathForLOB = () => {
        if (MLProductCodeUtil.isPersonalAuto(submissionVM.baseData.productCode.value)) { 
            return PA_QUESTIONSET_PATH;
        }   
        if (MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value)) {
            return HOP_QUESTIONSET_PATH;
        } 
        return "";
    };

    const questionSet = _.get(submissionVM, getPathForLOB());

    const {
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    // DEFAULTS
    const MAX_LENGTH_INSURANCE_CARRIER = 40;
    const MIN_LENGTH_WITH_CARRIER = 0;
    const MAX_LENGTH_WITH_CARRIER = 99;
    const MAX_DAYS_CURR_POLICY_EXPIRATION_DATE = -90;
    const BASE_10 = 10;

    // Question Identifiers
    const NO_INSURANCE_90_DAYS = 'InsuredPolicyLast90Days_ML';
    const CURRENT_INSURANCE_PROVIDER = 'CurrentInsuranceProvider_ML';
    const CURRENTLY_INSURED_ON_ANOTHER_POLICY = 'InsuredOnAnotherPolicy_ML';
    const NEW_PURCHASE_NO_PREVIOUS_OWNED_VEHICLE = 'NewPurchase_ML';
    const OWN_VEHICLES_BUT_NO_INSURANCE_90_DAYS = 'OwningNotInsuredVehicles_ML';
    const REGULAR_DRIVING_VEHICLE_BUT_NOT_LISTED_ON_AN_INSURANCE_POLICY = 'NotListedDriverOnPolicy_ML';
    const OTHER_CARRIER_NOT_LISTED = 'NotListedCarrierInsuredWith_ML';
    const OTHER_INSURANCE_NOT_LISTED = 'NotListedInsuranceProvider_ML';
    const LENGTH_WITH_CURRENT_CARRIER = 'LengthWithCurrentCarrier_ML';
    const LENGTH_WITH_CURRENT_CARRIER_FMPA = 'LengthWithCurrentCarrierFMPA_Ext';
    const CURRENT_EXPIRATION_DATE_OF_POLICY = 'CurrentExpirationDate_ML';
    const ON_ACTIVE_MILITARY = 'LapseDueToMilitaryService_Ext';
    const ACTIVE_MILITARY_QB = 'CoverageLapseDueToMilitaryService_Ext'
    const MILITARY_LENGTH_WITH_PRIOR_CARRIER = 'MilitaryTimeWithPriorCarrier_Ext';
    const CURRENT_LIABILITY_LIMIT = 'CurrentLiabilityLimitsLower_ML';
    const MILITARY_INSURANCE_PRIOR_TO_SERVICE = 'MilitaryInsurancePriorToService_Ext';
    const MILITARY_DETAILS_ABOUT_PRIOR_TO_SERVICE = 'MilitaryDetailsAboutPriorCoverage_Ext';
    const MILITARY_PRIOR_PROVIDER_OF_INSURANCE = 'MilitaryPriorProviderOfInsurance_Ext';
    const MILITARY_TIME_WITH_PRIOR_CARRIER = 'MilitaryTimeWithPriorCarrier_Ext';
    const MILITARY_PRIOR_LIABLIMITS_LOWER = 'MilitaryPriorLiabLimitsLower_Ext';
    const FMPA_CURRENTLIABILITY_LIMIT = 'CurrentLiabilityLimitsFMPA_Ext';

    
    const MULTILINE_INSURER_ANSWER = 'MultLineCurrentInsuranceProvider_Ext';

    const [continiousLiabilityMonths, setContiniousLiabilityMonths] = useState(0);
    const [disableEditing, setDisableEditing] = useState(false);
    const [isContinousLiabilityVisible, setIsContinousLiabilityVisible] = useState(false);
    const { authHeader } = useAuthentication();
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);

    React.useEffect(() => {
        // get lob
        const isPersonalAuto = submissionVM.value.isPersonalAuto();
        const isModernProductQB = _.get(submissionVM, "isModernProduct_Ext.value", false);
        
        if(isPersonalAuto){
            setIsContinousLiabilityVisible(true)
            // get and set months of continuous liability
            let allowPriorMonthsdEditing = _.get(submissionVM, 'lobData.personalAuto.allowPriorInsuranceMonthsEditing')
            let months = _.get(submissionVM, 'lobData.personalAuto.continuousLiabilityMonths')
            setContiniousLiabilityMonths(months.value);
            // get base state
            let baseState = _.get(submissionVM, 'baseData.policyAddress.state.value.code')
            // make api call to get script param
            MLPortalSettingsService.getSettings(authHeader).then((response) => {
                if(response){
                    var stateArr = response.priorInsurDisputeDisabledStates_Ext.split(",")
                    // if script param contains base state, disable editing
                    if(stateArr.includes(baseState)){
                        setDisableEditing(true)
                    }
                    else {
                       if( isQnB && !isModernProductQB ){    
                            setDisableEditing(allowPriorMonthsdEditing.value)
                        }else{
                            setDisableEditing(false)
                        }
                    }
                }
            })
        }
    }, [])

    const setComponentValidation = useCallback(() => {
        const errors = [];

        const validateNoPriorCarrierOrNoInsurance = () => {
            if (MLProductCodeUtil.isPersonalAuto(submissionVM.baseData.productCode.value)) {
                const message = translator(messages.NoCarrierOrNoInsuranceError);
                const noInsuranceAnswer = questionSet.answers[NO_INSURANCE_90_DAYS];
                const currentInsuranceAnswer = questionSet.answers[CURRENT_INSURANCE_PROVIDER];
                if ((noInsuranceAnswer === 'false' || noInsuranceAnswer === false)  && !currentInsuranceAnswer) {
                    errors.push(message);
                } else if (isQnB && isModernProduct && currentInsuranceAnswer === null){
                    errors.push(message);
                }
            } else if (MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value)) {
                const message = translator(messages.NoCarrierError);
                const insurerAnswer = questionSet.answers[MULTILINE_INSURER_ANSWER];
                if (insurerAnswer === null) {
                    errors.push(message);
                }
            }
        };

        const validateCurrentLiabilityLimitsLower = () => {
            if (!isQnB) return;

            const answers = questionSet?.answers || {};

            if (!_.has(answers, CURRENT_LIABILITY_LIMIT)) return;

            const value = _.get(answers, CURRENT_LIABILITY_LIMIT);

            if (_.isNil(value) || value === '') {
                errors.push(translator(messages.CurrentLiabilityLimitsLowerRequired));
                window.scrollTo(0, 0);
            }
        };

        const validateNotListedInsuranceProvider = () => {
            if (isQnB) {
                const answers = questionSet?.answers || {};

                if (!Object.prototype.hasOwnProperty.call(answers, OTHER_INSURANCE_NOT_LISTED)) {
                    return;
                }

                const otherInsuranceProvider = answers[OTHER_INSURANCE_NOT_LISTED];
                const messageLength = translator(messages.NotListedInsuranceProviderError);

                if (!otherInsuranceProvider || otherInsuranceProvider.trim() === '') {
                    errors.push(messageLength);
                    window.scrollTo(0, 0);
                    return;
                }

                if (otherInsuranceProvider.length > MAX_LENGTH_INSURANCE_CARRIER) {
                    errors.push(messageLength);
                    window.scrollTo(0, 0);
                }
            } else {
                const otherInsuranceProvider = questionSet.answers[OTHER_INSURANCE_NOT_LISTED];
                const message = translator(messages.NotListedInsuranceProviderError);
                if (!!otherInsuranceProvider && otherInsuranceProvider.length > MAX_LENGTH_INSURANCE_CARRIER) {
                    errors.push(message);
                }
            }
        };

        const validateNotListedCarrier = () => {
            const otherCarrier = questionSet.answers[OTHER_CARRIER_NOT_LISTED];
            const message = translator(messages.NotListedCarrierInsuredError);
            if (!!otherCarrier && otherCarrier.length > MAX_LENGTH_INSURANCE_CARRIER) {
                errors.push(message);
            }
        };

        const validateActiveMilitaryService = () => {
            if (!isQnB || (isQnB && isModernProduct)) return;

            const answers = questionSet?.answers || {};
            const activeMilitaryService = answers[ACTIVE_MILITARY_QB];
            const carrierPolicyExpirationDate = answers[CURRENT_EXPIRATION_DATE_OF_POLICY];
            const currentDate = new Date();
            const message = translator(messages.ActiveMilitaryServiceError);

            if (carrierPolicyExpirationDate) {
                const [year, month, date] = carrierPolicyExpirationDate.split('-');
                const currentExpirydateOfPolicy = new Date(`${Number(month) + 1}/${date}/${year}`);
                const onlyCurrentDate = new Date(`${Number(currentDate.getMonth()) + 1}/${currentDate.getDate()}/${currentDate.getFullYear()}`);
                const differenceInDays = MLLocalDateUtil.differenceInDays(currentExpirydateOfPolicy, onlyCurrentDate);

                if (!(currentExpirydateOfPolicy >= onlyCurrentDate) && _.isNil(activeMilitaryService) && !(differenceInDays <= MAX_DAYS_CURR_POLICY_EXPIRATION_DATE)) {
                    errors.push(message);
                } 
            } else if (_.has(answers, ACTIVE_MILITARY_QB) && (_.isNil(activeMilitaryService) || activeMilitaryService === '')) {
                errors.push(message);
            }
        }

        const OriginalEffectiveDate = () => {
            let originalDate = null;

            if (MLProductCodeUtil.isPersonalAuto(submissionVM.baseData.productCode.value)) {
                originalDate = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.answers.value.TenureOriginalEffDate_Ext');
            }
            if (MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value)) {
                originalDate = _.get(submissionVM, 'lobData.homeowners.priorInsurance.value[0].answers.MultiLineTenureEffDate_Ext');
            }
            const originalDateMessage = translator(messages.OriginalEffectiveDate);
            const futureDateMessage = translator(messages.FutureEffectiveDate);

            if (!_.isUndefined(originalDate) && originalDate !== null ) {
                const dateIsValid = moment(originalDate, "MM/YYYY", true).isValid();
                if (dateIsValid === true) {
                    const [month, year] = originalDate.split('/');
                    const convertMonthYearToActualDate = new Date(`${month}/01/${year}`);
                    if (convertMonthYearToActualDate.getTime() > Date.now()) {
                        errors.push(futureDateMessage);
                    }
                } else {
                    errors.push(originalDateMessage);
                }
            }
        };

        const companyPolicyNumner = () => {

            let policyNumber = null;

            if (MLProductCodeUtil.isPersonalAuto(submissionVM.baseData.productCode.value)) {
                policyNumber = _.get(submissionVM, 'lobData.personalAuto.questionSets_ML.priorInsurance.answers.value.CompanyPolicyNumber_Ext');
            }
            if (MLProductCodeUtil.isHomeOwners(submissionVM.baseData.productCode.value)) {
                policyNumber = _.get(submissionVM, 'lobData.homeowners.priorInsurance.value[0].answers.MultiLinePolicyNumber_Ext');
            }

            const message = translator(messages.CompanyPolicyNumber);
            const messageIsNull = translator(messages.CompanyPolicyNumberIsNull)

            if (!_.isUndefined(policyNumber) && policyNumber !== null ) {
                if (policyNumber.length > 25 || !/^[a-zA-Z0-9]+$/.test(policyNumber)) {
                    errors.push(message);
                } 
            }
        };

        const validateLengthWithCurrentCarrier = () => {
            const lengthWithCarrier = isModernProduct ? questionSet.answers[LENGTH_WITH_CURRENT_CARRIER_FMPA] : questionSet.answers[LENGTH_WITH_CURRENT_CARRIER];
            const message = translator(messages.LengthWithCurrentCarrierError);
            try {
                if (lengthWithCarrier) {
                    const min = parseInt(lengthWithCarrier, BASE_10);
                    const max = parseInt(lengthWithCarrier, BASE_10);
                    if (min < MIN_LENGTH_WITH_CARRIER || max > MAX_LENGTH_WITH_CARRIER) {
                        errors.push(message);
                    }
                } else if (lengthWithCarrier === ""){
                    errors.push(message);
                } else if (lengthWithCarrier === null && isQnB){
                    errors.push(message)
                }
            } catch (e) {
                errors.push(message);
            }
        };

        const validateCarrierPolicyExpirationDate = () => {
            const carrierPolicyExpirationDate = questionSet.answers[CURRENT_EXPIRATION_DATE_OF_POLICY];
            const message = translator(messages.ExpirationDateError);

            clearBlockAlerts('ExpirationDateError');
            if (!!carrierPolicyExpirationDate) {
                const localDate = MLLocalDateUtil.parseLocalDateString2LocalDate(carrierPolicyExpirationDate);
                const toDate = MLLocalDateUtil.localDate2Date(localDate);
                const currentDate = new Date();
                const differenceInDays = MLLocalDateUtil.differenceInDays(toDate, currentDate);

                if (differenceInDays <= MAX_DAYS_CURR_POLICY_EXPIRATION_DATE) {
                    errors.push(message);
                }
            } else if (_.has(questionSet.answers, CURRENT_EXPIRATION_DATE_OF_POLICY) && (_.isNil(carrierPolicyExpirationDate) || carrierPolicyExpirationDate === '')) {
                    errors.push(message);
            }
        };

        const validateOtherOrNoInsurance = () => {
            let counter = 0;
            const insuredOnAnotherPolicy = questionSet.answers[CURRENTLY_INSURED_ON_ANOTHER_POLICY];
            const newPurchase = questionSet.answers[NEW_PURCHASE_NO_PREVIOUS_OWNED_VEHICLE];
            const owningNotInsured = questionSet.answers[OWN_VEHICLES_BUT_NO_INSURANCE_90_DAYS];
            const notListedOnPolicy = questionSet.answers[REGULAR_DRIVING_VEHICLE_BUT_NOT_LISTED_ON_AN_INSURANCE_POLICY];
            const noInsurance = questionSet.answers[NO_INSURANCE_90_DAYS];
            const activeMilitary = questionSet.answers[ON_ACTIVE_MILITARY];
            const message = translator(messages.OtherOrNoInsuranceError);

            if (insuredOnAnotherPolicy === 'true') counter += 1;
            if (newPurchase === 'true') counter += 1;
            if (owningNotInsured === 'true') counter += 1;
            if (notListedOnPolicy === 'true') counter += 1;
            if (activeMilitary === 'true') counter += 1;

            if (noInsurance === 'true' && counter !== 1) {
                errors.push(message);
            }
        };

        const validateMilitaryLengthWithPriorCarrier = () => {
            const militaryLengthWithPriorCarrier = questionSet.answers[MILITARY_LENGTH_WITH_PRIOR_CARRIER];
            const message = translator(messages.MilitaryLengthWithPriorCarrierError);
            try {
                if (!!militaryLengthWithPriorCarrier) {
                    const min = parseInt(militaryLengthWithPriorCarrier, BASE_10);
                    const max = parseInt(militaryLengthWithPriorCarrier, BASE_10);
                    if (min < MIN_LENGTH_WITH_CARRIER || max > MAX_LENGTH_WITH_CARRIER) {
                        errors.push(message);
                    }
                }
            } catch (e) {
                console.error(e);
                errors.push(message);
            }
        };

        const validateOnActiveMilitaryService = () => {
            if (!isQnB) return;

            const answers = questionSet?.answers || {};
            const priorMilitary = answers[MILITARY_INSURANCE_PRIOR_TO_SERVICE];
            const priorMilitaryDetails = answers[MILITARY_DETAILS_ABOUT_PRIOR_TO_SERVICE];
            const priorInsuranceDetails = answers[MILITARY_PRIOR_PROVIDER_OF_INSURANCE];
            const priorCarrierDetails = answers[MILITARY_TIME_WITH_PRIOR_CARRIER];
            const priorLiabilimitsDetails = answers[MILITARY_PRIOR_LIABLIMITS_LOWER];
 
            const priorMilitaryMessage = translator(messages.MilitaryInsurancePriorToServiceRequired);
            const priorMilitaryDetailsMessage = translator(messages.MilitaryInsuranceAboutPriorToServiceRequired);
            const priorMilitaryInsuranceDetailsMessage = translator(messages.MilitaryPriorInsurance);
            const priorCarrierDetailsMessage = translator(messages.yourPriorCarrier);
            const priorLiabilimitsDetailsMessage = translator(messages.priorLiabilityLimits);
 
            if ( _.has(answers, MILITARY_INSURANCE_PRIOR_TO_SERVICE) && (_.isNil(priorMilitary) || priorMilitary === '')) {
                errors.push(priorMilitaryMessage);
            }
            if ( _.has(answers, MILITARY_DETAILS_ABOUT_PRIOR_TO_SERVICE) &&  (_.isNil(priorMilitaryDetails) || priorMilitaryDetails === '')) {
                errors.push(priorMilitaryDetailsMessage);
            }
            if ( _.has(answers, MILITARY_PRIOR_PROVIDER_OF_INSURANCE) &&  (_.isNil(priorInsuranceDetails) || priorInsuranceDetails === '')) {
                errors.push(priorMilitaryInsuranceDetailsMessage);
            }
            if ( _.has(answers, MILITARY_TIME_WITH_PRIOR_CARRIER) &&  (_.isNil(priorCarrierDetails) || priorCarrierDetails === '')) {
                errors.push(priorCarrierDetailsMessage);
            }
            if ( _.has(answers, MILITARY_PRIOR_LIABLIMITS_LOWER) &&  (_.isNil(priorLiabilimitsDetails) || priorLiabilimitsDetails === '')) {
                errors.push(priorLiabilimitsDetailsMessage);
            }
        };

        const validateCurrentLiabilityLimitsFMPA_Ext = () => {
            if (!isQnB) return;

            const answers = questionSet?.answers || {};

            if (!_.has(answers, FMPA_CURRENTLIABILITY_LIMIT)) return;

            const value = _.get(answers, FMPA_CURRENTLIABILITY_LIMIT);

            if (_.isNil(value) || value === '') {
                errors.push(translator(messages.CurrentLiabilityLimitsLowerRequired));
                window.scrollTo(0, 0);
            }
        };

        validateOnActiveMilitaryService()
        validateNoPriorCarrierOrNoInsurance();
        validateNotListedInsuranceProvider();
        validateCurrentLiabilityLimitsLower();
        validateNotListedCarrier();
        validateLengthWithCurrentCarrier();
        validateActiveMilitaryService();
        validateCarrierPolicyExpirationDate();
        validateOtherOrNoInsurance();
        validateMilitaryLengthWithPriorCarrier();
        OriginalEffectiveDate();
        companyPolicyNumner();
        validateCurrentLiabilityLimitsFMPA_Ext();

        onUpdateErrors(errors);
    }, [JSON.stringify(questionSet.answers)]);

    const onValueChange = useCallback((aQuestionSetAnswersValue, pathToAnswers, qsQuestionType) => {
        if (qsQuestionType !== 'String' &&  qsQuestionType !== 'Integer' && qsQuestionType !== 'Date') {
            updateShowPriorInsuranceErrors(false);
            syncQuestionSets(aQuestionSetAnswersValue);
        } else {
            _.set(submissionVM, pathToAnswers, aQuestionSetAnswersValue);
            refreshData();
        }
        updateWizardData(submissionVM);
    }, [refreshData, submissionVM, syncQuestionSets, updateShowPriorInsuranceErrors]);

    const handleOnBlur = useCallback((evt, inputObj, qsQuestionType, aQuestionSetAnswersValue) => {
        // check if progress dialog is causing the onBlur event and if so, do not trigger another sync call
        const isTargetModal = evt?.relatedTarget?.className?.indexOf('ml-modal-loading') > -1;
        if ((qsQuestionType === 'String' || qsQuestionType === 'Integer' || qsQuestionType === 'Date') && !isTargetModal) {
            updateShowPriorInsuranceErrors(false);
            if(!isQnB){
                syncQuestionSets(evt);
            } else {
                syncQuestionSets(aQuestionSetAnswersValue, evt.relatedTarget);
            }
        }
    }, [syncQuestionSets, updateShowPriorInsuranceErrors]);

    const updateContiniousLiabilityMonths = useCallback((value) => {
        setContiniousLiabilityMonths(value);
        _.set(submissionVM, 'lobData.personalAuto.continuousLiabilityMonths', value);
        updateWizardData(submissionVM);
    }, [continiousLiabilityMonths, submissionVM, updateWizardData]);

    const filterCurrentInsuranceProviderChoices = useCallback(() => {
        const baseState = _.get(submissionVM, 'baseData.policyAddress.state.value.code')
        const filterChoicesList = [];
        let choicesToFilter = null;

        if (isModernProduct && baseState != 'UT') {
            choicesToFilter = {
                fieldName: CURRENT_INSURANCE_PROVIDER,
                filterList: ['CurrentInsuranceProviderInnocentNoPriorFirstCar_Ext', 'CurrentInsuranceProviderInnocentNoPriorInStorage_Ext']
            }
            filterChoicesList.push(choicesToFilter)
        } else if (!isModernProduct) {
            choicesToFilter = {
                fieldName: CURRENT_INSURANCE_PROVIDER,
                filterList: ['CurrentInsuranceProviderNoPriorInsurance_Ext', 'CurrentInsuranceProviderInnocentNoPriorMilitary_Ext', 'CurrentInsuranceProviderInnocentNoPriorAllOther_Ext',
                    'CurrentInsuranceProviderInnocentNoPriorFirstCar_Ext', 'CurrentInsuranceProviderInnocentNoPriorInStorage_Ext']
            }
            filterChoicesList.push(choicesToFilter)
        }

        return filterChoicesList;
    }, [isModernProduct, submissionVM]);

    const overrideProps = {
        questionset: {
            labelPosition: 'top',
            path: getPathForLOB(),
            model: submissionVM,
            onValueChange: onValueChange,
            showErrors,
            onValidate,
            showOptionalML: false,
            showHeaderML: !isGpa,
            isFieldDefaultedByHVQ,
            onBlur: handleOnBlur,
            currentStep,
            filterChoicesLists: filterCurrentInsuranceProviderChoices,
            title : !isQnB
        },
        monthsOfLiability: {
            value: continiousLiabilityMonths,
            disabled: disableEditing,
            visible: isContinousLiabilityVisible,
            onValueChange: updateContiniousLiabilityMonths,
            className: isQnB ? 'jut__FieldComponent__reversed flex-column-qs-qb' : 'jut__FieldComponent__reversed flex-column-qs'
        }
    };

    const resolvers = {
        resolveComponentMap: { questionset: QuestionSetComponent }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onModelChange={updateWizardData}
            onValidationChange={setComponentValidation}
            showErrors={showErrors}
        />
    );
}


PriorInsuranceComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    updateWizardData: PropTypes.func.isRequired,
    onUpdateErrors: PropTypes.func.isRequired,
    syncQuestionSets: PropTypes.func.isRequired,
    showErrors: PropTypes.bool.isRequired,
    isGpa: PropTypes.bool,
    isFieldDefaultedByHVQ: PropTypes.func
};

PriorInsuranceComponent.defaultProps = {
    isGpa: false,
    isFieldDefaultedByHVQ: undefined
};

export default PriorInsuranceComponent;
